module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-LightItalic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-LightItalic.eot
// module id = 8
// module chunks = 8